import styles from "./HeroPage.module.scss";
import Header from "../../components/header/Header";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../constants/routes";
import { useState, useRef, useEffect } from "react";
import useWindowSize from "../../hooks/useWindowSize";

const HeroPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeFeature, setActiveFeature] = useState<number | null>(null);
  const [bannerKey, setBannerKey] = useState(0);
  const bannerRef = useRef<HTMLDivElement>(null);
  const { windowSize } = useWindowSize();
  const isMobile = windowSize === "mobile";

  useEffect(() => {
    if (activeFeature !== null) {
      setBannerKey((k) => k + 1);
    }
  }, [activeFeature]);

  const startHandler = () => {
    localStorage.setItem("heroSeen", "1");
    navigate(ROUTES.FOR_YOU);
  };

  const features = [
    {
      label: t("hero_swipe"),
      desc: t("hero_swipe_desc"),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
            d="M12 2a2 2 0 0 1 2 2v6.5" />
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
            d="M14 11.5a1.5 1.5 0 0 1 3 0v.5" />
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
            d="M17 12.5a1.5 1.5 0 0 1 3 0V15a7 7 0 0 1-7 7H11a7 7 0 0 1-5.6-2.8L3 16" />
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
            d="M10 10.5V4a2 2 0 1 1 4 0" />
          <path stroke="currentColor" strokeLinecap="round" strokeWidth={1.5}
            d="M1 6l2.5-3m0 0l2.5 3M3.5 3v5" />
        </svg>
      ),
    },
    {
      label: t("hero_save"),
      desc: t("hero_save_desc"),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
      ),
    },
    {
      label: t("hero_share"),
      desc: t("hero_share_desc"),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width={22} height={20} fill="none" viewBox="0 0 20 18">
          <path stroke="currentColor" strokeWidth={1.5}
            d="M11.001 13.315v3.364l7.909-7.68L11 1.319V5.666l-.953.044c-3.316.156-5.65 1.386-7.12 3.566-1.161 1.721-1.836 4.139-1.92 7.271.99-1.228 2.027-2.273 3.427-3.01h.001c1.483-.78 3.284-1.152 5.534-1.222l1.031-.031v1.031Z" />
        </svg>
      ),
    },
  ];

  return (
    <div className={styles.wrapper}>
      <Header source="hero" className={styles.header} />

      <div
        ref={bannerRef}
        key={bannerKey}
        className={`${styles.banner} ${activeFeature !== null ? styles.bannerVisible : styles.bannerHidden}`}
      >
        <div className={styles.bannerGlow} />
        <div className={styles.bannerCard}>
          <div className={styles.bannerAccent} />
          <p className={styles.bannerText}>
            {activeFeature !== null ? features[activeFeature].desc : ""}
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <h1 className={styles.title}>{t("hero_title")}</h1>

        <div className={styles.features}>
          {features.map((f, i) => (
            <div
              key={i}
              className={`${styles.featureItem} ${activeFeature === i ? styles.featureItemActive : ""}`}
              {...(isMobile
                ? { onClick: () => setActiveFeature(activeFeature === i ? null : i) }
                : { onMouseEnter: () => setActiveFeature(i), onMouseLeave: () => setActiveFeature(null) }
              )}
            >
              <div className={styles.iconWrapper}>
                <div className={styles.iconInner}>
                  {f.icon}
                </div>
              </div>
              <span className={styles.featureLabel}>{f.label}</span>
            </div>
          ))}
        </div>

        <button className={styles.cta} onClick={startHandler}>
          {t("hero_cta")}
        </button>
      </div>
    </div>
  );
};

export default HeroPage;
